import { UsersAPI } from "./routers/users";
import { ProagricaAPI } from "./routers/proagrica";
import { AgrianAPI } from "./routers/agrian";
import { StandardAxiosConfig } from "./common";
// import { AgVanceAPI } from "./routers/agvance";
import axios from "axios";
import {
	BranchesAPI,
	CompaniesAPI,
	ContactsAPI,
	DealsAPI,
	GrowersAPI,
	JobsAPI,
	JobsReadyAPI,
	RegionsAPI,
	TeamMembersAPI as TeamMembersAPI,
} from "./routers/data/tables";
import { MissionControlAPI } from "./routers/mission-control";
import { MissionsAPI } from "./routers/missions";

export namespace API {
	export const Users = new UsersAPI();
	export const MissionControl = new MissionControlAPI();
	export const Missions = new MissionsAPI();
	export namespace Integrations {
		export const Proagrica = new ProagricaAPI();
		export const Agrian = new AgrianAPI();
		// export const AgVance = new AgVanceAPI();
	}
	export namespace Data {
		export async function clearCache() {
			await axios.get(`${import.meta.env.VITE_ROGO_API_URL}/cache/clear`, StandardAxiosConfig());
			await axios.get(`${import.meta.env.VITE_ROGO_API_URL}/proagrica/cache/clear`, StandardAxiosConfig());
			await axios.get(`${import.meta.env.VITE_ROGO_API_URL}/agrian/cache/clear`, StandardAxiosConfig());
		}
		export const Contacts = new ContactsAPI();
		export const Jobs = new JobsAPI();
		export const Deals = new DealsAPI();
		export const Companies = new CompaniesAPI();
		export const Growers = new GrowersAPI();
		export const Branches = new BranchesAPI();
		export const Regions = new RegionsAPI();
		export const JobsReady = new JobsReadyAPI();
		export const TeamMembers = new TeamMembersAPI();
	}
}
